/**
 * Created with IntelliJ IDEA.
 * User: lironc
 * Date: 11/5/13
 * Time: 4:06 PM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {

    window.lpTag = window.lpTag || {};
    window.lpTag.WebAgent = window.lpTag.WebAgent || {};
    var agentLEManager = require('web-agent-utils/agentLEManager');

    var WebAgentLogger = function () {

        var logger = agentLEManager.loggerLE();
        if (!logger) {
            logger = {
                error : createLogFunc("ERROR"),
                warn : createLogFunc("WARN"),
                info : createLogFunc("INFO"),
                debug : createLogFunc("DEBUG"),
                graph : createLogFunc("GRAPH")
            };
        }
        return logger;

        function createLogFunc(level) {
            return function (message, methodName, obj) {
                if (window.console) {
                    if (level === "ERROR" && window.console.error) {
                        var msg = level;
                        if(message) {
                            msg += (":" + message);
                        }
                        if(methodName) {
                            msg += (":" + methodName);
                        }
                        window.console.error(msg + ", " + getLogDateTime(), obj);
                    }
                }
            };
        }

        function getLogDateTime() {
            var now = new Date();
            var fixTime = function (num) {
                return (num < 10) ? "0" + num : num;
            };
            var dateStr = fixTime(now.getHours()) + ":" + fixTime(now.getMinutes()) + ":" + fixTime(now.getSeconds()) + ", " + now.toDateString() + ", (" + now.getTime() + ")";
            return dateStr;
        }
    };

    WebAgentLogger.getLogger = function (componentName) {
        return {
            error: createLogFunc("error", componentName),
            warn: createLogFunc("warn", componentName),
            info: createLogFunc("info", componentName),
            debug: createLogFunc("debug", componentName),
            graph: createGraphFunc(componentName)
        };

        function createLogFunc(level, componentName) {
            return function (message, methodName, obj) {

                try {
                    message = typeof message === "object" ? JSON.stringify(message) : message;
                } catch(err) {
                    message = "[recursive object]";
                }

                var namespace = componentName;

                if (methodName) {
                    namespace += ("#" + methodName);
                }

                if (lpTag.WebAgent && lpTag.WebAgent.logger && lpTag.WebAgent.logger[level]) {
                    lpTag.WebAgent.logger[level](message, namespace, obj);
                } else if (lpTag.WebAgent && lpTag.WebAgent.logger) { // if the level of log is unsupported log as error.
                    lpTag.WebAgent.logger.error(message, namespace, obj);
                }
            };
        }

        function createGraphFunc(componentName) {
            return function (data) {
                data.name = 'WebAgent:' + componentName + ':' + data.name;
                if (lpTag.WebAgent && lpTag.WebAgent.logger && lpTag.WebAgent.logger.graph) {
                    lpTag.WebAgent.logger.graph(data);
                } else if (lpTag.WebAgent && lpTag.WebAgent.logger) { // if the level of log is unsupported log as error.
                    lpTag.WebAgent.logger.error(JSON.stringify(data));
                }
            };
        }

    };

    return WebAgentLogger;

});
